window.GAYA_HOME_WA_ATTRIBUTION_COOKIE = 'gh_wa_attribution';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + encodeURIComponent(value || '') + expires + '; path=/; SameSite=None; Secure';
}

function getCookie(name) {
  var nameEQ = name + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) {
      try {
        return decodeURIComponent(c.substring(nameEQ.length, c.length));
      } catch (e) {
        return c.substring(nameEQ.length, c.length);
      }
    }
  }
  return null;
}

function setLocalStorageItem(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    console.warn('Unable to persist localStorage item:', key, e);
  }
}

function getLocalStorageItem(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function isTikTokUrl(url) {
  if (!url) return false;

  try {
    var parsed = new URL(url, window.location.origin);
    var host = (parsed.hostname || '').toLowerCase();
    return host.indexOf('tiktok.com') !== -1;
  } catch (e) {
    return /(^|\/\/)([^\/]+\.)?tiktok\.com/i.test(url);
  }
}

function isLemon8Url(url) {
  if (!url) return false;

  try {
    var parsed = new URL(url, window.location.origin);
    var host = (parsed.hostname || '').toLowerCase();
    return host.indexOf('lemon8') !== -1;
  } catch (e) {
    return /(^|\/\/)([^\/]+\.)?lemon8/i.test(url);
  }
}

function readWhatsAppAttribution() {
  var values = [
    getCookie(window.GAYA_HOME_WA_ATTRIBUTION_COOKIE),
    getLocalStorageItem(window.GAYA_HOME_WA_ATTRIBUTION_COOKIE)
  ];

  for (var i = 0; i < values.length; i++) {
    if (!values[i]) continue;

    try {
      return JSON.parse(values[i]);
    } catch (e) {}
  }

  return null;
}

function persistWhatsAppAttribution(data, days) {
  try {
    var serialized = JSON.stringify(data);
    setCookie(window.GAYA_HOME_WA_ATTRIBUTION_COOKIE, serialized, days || 30);
    setLocalStorageItem(window.GAYA_HOME_WA_ATTRIBUTION_COOKIE, serialized);
  } catch (e) {
    console.warn('Unable to persist WhatsApp attribution:', e);
  }
}

function refreshFacebookClickCookie(fbclid) {
  if (!fbclid) return '';

  var existingFbc = getCookie('_fbc') || '';
  if (existingFbc.endsWith('.' + fbclid)) {
    return existingFbc;
  }

  var prefixMatch = existingFbc.match(/^(fb\.\d+)\./);
  var prefix = prefixMatch ? prefixMatch[1] : 'fb.1';
  var fbc = prefix + '.' + Date.now() + '.' + fbclid;
  setCookie('_fbc', fbc, 90);

  return fbc;
}

function captureWhatsAppAttribution() {
  var params = new URLSearchParams(window.location.search);
  var stored = readWhatsAppAttribution() || {};
  var currentReferrer = document.referrer || '';
  var explicitSource = (params.get('gh_source') || '').toLowerCase();
  var utmSource = (params.get('utm_source') || '').toLowerCase();
  var currentTtclid = params.get('ttclid') || '';
  var currentFbclid = params.get('fbclid') || '';
  var isSameMetaClick = Boolean(
    currentFbclid &&
    stored.source === 'FACEBOOK' &&
    stored.fbclid === currentFbclid
  );
  if (currentFbclid) {
    refreshFacebookClickCookie(currentFbclid);
  }

  function currentMetaValue(value, storedKey) {
    if (value) return value;
    return isSameMetaClick ? (stored[storedKey] || '') : '';
  }

  var hasCurrentMetaAttribution = Boolean(
    currentFbclid ||
    params.get('campaign_id') ||
    params.get('adset_id') ||
    params.get('ad_id') ||
    ['facebook', 'instagram', 'fb', 'ig', 'an'].indexOf(utmSource) !== -1
  );
  var hasExplicitTikTokAttribution = Boolean(
    explicitSource === 'tiktok' ||
    currentTtclid ||
    utmSource === 'tiktok'
  );
  var hasExplicitLemon8Attribution = Boolean(
    explicitSource === 'lemon8' ||
    utmSource === 'lemon8'
  );
  var hasCurrentTikTokAttribution = hasExplicitTikTokAttribution ||
    (!hasCurrentMetaAttribution && !hasExplicitLemon8Attribution && isTikTokUrl(currentReferrer));
  var hasCurrentLemon8Attribution = hasExplicitLemon8Attribution ||
    (!hasCurrentMetaAttribution && !hasExplicitTikTokAttribution && isLemon8Url(currentReferrer));

  var attribution = Object.assign({}, stored, {
    last_seen_url: window.location.href,
    updated_at: new Date().toISOString()
  });

  if (hasCurrentTikTokAttribution || hasCurrentLemon8Attribution) {
    attribution = {
      source: hasCurrentTikTokAttribution ? 'TIKTOK' : 'LEMON8',
      ttclid: currentTtclid,
      fbclid: '',
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      campaign_id: '',
      campaign_name: params.get('utm_campaign') || '',
      adset_id: '',
      adset_name: '',
      ad_id: '',
      ad_name: params.get('utm_content') || '',
      placement: params.get('placement') || '',
      landing_url: window.location.href,
      referrer: currentReferrer,
      last_seen_url: window.location.href,
      updated_at: new Date().toISOString()
    };
  } else if (hasCurrentMetaAttribution) {
    attribution = {
      source: 'FACEBOOK',
      ttclid: '',
      fbclid: currentFbclid,
      utm_source: currentMetaValue(params.get('utm_source'), 'utm_source'),
      utm_medium: currentMetaValue(params.get('utm_medium'), 'utm_medium'),
      campaign_id: currentMetaValue(params.get('campaign_id') || params.get('utm_id'), 'campaign_id'),
      campaign_name: currentMetaValue(params.get('campaign_name') || params.get('utm_campaign'), 'campaign_name'),
      adset_id: currentMetaValue(params.get('adset_id'), 'adset_id'),
      adset_name: currentMetaValue(params.get('adset_name'), 'adset_name'),
      ad_id: currentMetaValue(params.get('ad_id'), 'ad_id'),
      ad_name: currentMetaValue(params.get('ad_name') || params.get('utm_content'), 'ad_name'),
      placement: currentMetaValue(params.get('placement'), 'placement'),
      landing_url: isSameMetaClick && stored.landing_url ? stored.landing_url : window.location.href,
      referrer: isSameMetaClick && stored.referrer ? stored.referrer : currentReferrer,
      last_seen_url: window.location.href,
      updated_at: new Date().toISOString()
    };
  }

  if (hasCurrentMetaAttribution || hasCurrentTikTokAttribution || hasCurrentLemon8Attribution) {
    persistWhatsAppAttribution(attribution, 30);
  }

  window.gayaHomeAttribution = attribution;
}

var externalID = getCookie('external_id');
if (!externalID) {
  externalID = generateUUID();
  setCookie('external_id', externalID, 30);
}

captureWhatsAppAttribution();
